import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const BASE_ENDPOINT = '/retailers/{{retailerId}}/insights'

export default {
  /**
   * Get paginated insights with optional filters
   * @param {String} retailerId
   * @param {Object} params - { status, severity, type, from, to, page, limit }
   * @returns {Promise}
   */
  async getInsights(retailerId, params = {}) {
    const url = replacePathTokens(BASE_ENDPOINT, { retailerId })
    return $fetch.peg(url, { params })
  },

  /**
   * Get active insight count (for nav badge)
   * @param {String} retailerId
   * @returns {Promise}
   */
  async getActiveCount(retailerId) {
    const url = replacePathTokens(`${BASE_ENDPOINT}/count`, { retailerId })
    return $fetch.peg(url)
  },

  /**
   * Acknowledge an insight
   * @param {String} retailerId
   * @param {String} insightId
   * @returns {Promise}
   */
  async acknowledge(retailerId, insightId) {
    const url = replacePathTokens(`${BASE_ENDPOINT}/${insightId}/acknowledge`, { retailerId })
    return $fetch.peg(url, { method: 'PUT' })
  },

  /**
   * Dismiss an insight
   * @param {String} retailerId
   * @param {String} insightId
   * @returns {Promise}
   */
  async dismiss(retailerId, insightId) {
    const url = replacePathTokens(`${BASE_ENDPOINT}/${insightId}/dismiss`, { retailerId })
    return $fetch.peg(url, { method: 'PUT' })
  },
}
